import React from 'react';
import { Facebook, Twitter } from 'lucide-react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <motion.footer
      initial={{ y: 100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
      style={{
        backgroundColor: '#0073e6',
        color: 'white',
        padding: '10px 0',
        textAlign: 'center',
        marginTop: 'auto', // Ensure the footer sticks to the bottom
        flexShrink: 0, // Prevent footer from shrinking
      }}
    >
      <p>&copy; 2025 SmartKidsPrep. All Rights Reserved.</p>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <a
          href="https://facebook.com"
          style={{ color: 'white', margin: '0 10px' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Facebook size={24} />
        </a>
        <a
          href="https://twitter.com"
          style={{ color: 'white', margin: '0 10px' }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Twitter size={24} />
        </a>
      </div>
    </motion.footer>
  );
};

export default Footer;
